(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const reducido = () => matchMedia("(prefers-reduced-motion: reduce)").matches;
  const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const textos = window.SENS_TEXTOS || {};

  /* ---------- paneles: carrito y menú ---------- */
  let abierto = null, focoPrevio = null;
  function abrir(id) {
    const panel = document.getElementById(id);
    if (!panel) return;
    focoPrevio = document.activeElement;
    abierto = panel;
    panel.classList.add("abierto"); panel.setAttribute("aria-hidden", "false");
    $("#velo").classList.add("abierto"); document.body.style.overflow = "hidden";
    setTimeout(() => { const c = $("[data-foco]", panel) || $(".cerrar", panel); c && c.focus({ preventScroll: true }); }, 60);
  }
  function cerrar() {
    if (!abierto) return;
    abierto.classList.remove("abierto"); abierto.setAttribute("aria-hidden", "true");
    $("#velo").classList.remove("abierto"); document.body.style.overflow = "";
    abierto = null;
    if (focoPrevio && focoPrevio.isConnected) focoPrevio.focus({ preventScroll: true });
  }
  window.SENS = { abrir, cerrar };
  document.addEventListener("click", e => {
    const a = e.target.closest("[data-abrir]");
    if (a) { e.preventDefault(); abrir(a.dataset.abrir); return; }
    if (e.target.closest("[data-cerrar]") || e.target.id === "velo") cerrar();
  });
  document.addEventListener("keydown", e => {
    if (e.key !== "Escape") return;
    cerrar();
    $$(".nav-grupo[open]").forEach(d => { d.open = false; $("summary", d).focus(); });
  });
  // el desplegable del menú se cierra al hacer clic fuera
  document.addEventListener("click", e => { $$(".nav-grupo[open]").forEach(d => { if (!d.contains(e.target)) d.open = false; }); });

  /* ---------- carrito (API Ajax + Section Rendering) ---------- */
  const SECCIONES = "cart-drawer,header";
  function pintarSecciones(sec) {
    if (!sec) return;
    setTimeout(() => sincronizarEnvoltura().catch(() => {}), 0);
    setTimeout(() => cargarSugerencias(), 0);
    if (sec["cart-drawer"]) {
      const nuevo = new DOMParser().parseFromString(sec["cart-drawer"], "text/html");
      ["#carrito-cuerpo", "#carrito-pie"].forEach(sel => { const a = $(sel), b = $(sel, nuevo); if (a && b) a.innerHTML = b.innerHTML; });
    }
    if (sec.header) {
      const nuevo = new DOMParser().parseFromString(sec.header, "text/html");
      const c = $("#contador"), n = $("#contador", nuevo);
      if (c && n && c.textContent !== n.textContent) {
        c.textContent = n.textContent; c.hidden = n.hidden;
        $$("[data-espejo-contador]").forEach(x => x.textContent = n.textContent);
        c.classList.remove("salta"); void c.offsetWidth; c.classList.add("salta");
      }
    }
  }
  const cacheSug = {};
  // mismo formato que el resto de la tienda ($11.95)
  const dinero = c => "$" + (c / 100).toFixed(2);
  const escHtml = t => String(t ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
  const sinMarca = p => p.title.toLowerCase().startsWith(p.vendor.toLowerCase() + " ") ? p.title.slice(p.vendor.length + 1) : p.title;
  /* "Completa tu ritual": primero la lista curada (colección complementos, en su orden: productos pequeños que suben el ticket);
     si falta poco para el envío gratis, el más barato que lo alcanza va primero con la nota "Con este llegas al envío gratis";
     si faltan sugerencias, se completan con las recomendaciones de Shopify. Nunca repite lo que ya está en el carrito. */
  async function cargarSugerencias() {
    const caja = $("[data-sugerencias]");
    if (!caja) return;
    const enCarrito = $$("[data-producto-carrito]").map(l => l.dataset.productoCarrito);
    if (!enCarrito.length) { caja.hidden = true; return; }
    let curados = [];
    try { curados = JSON.parse(($("[data-complementos]") || {}).textContent || "[]"); } catch (e) {}
    curados = curados.filter(p => !enCarrito.includes(String(p.id)));
    const falta = +(($("[data-envio-gratis]") || {}).dataset?.falta || 0);
    let elegidos = [], alcanza = null;
    if (falta > 0) {
      alcanza = curados.filter(p => p.precio >= falta).sort((a, b) => a.precio - b.precio)[0] || null;
      if (alcanza) elegidos.push(alcanza);
    }
    curados.forEach(p => { if (elegidos.length < 3 && !elegidos.includes(p)) elegidos.push(p); });
    if (elegidos.length < 3) {   // relleno con recomendaciones de Shopify
      const base = enCarrito[enCarrito.length - 1];
      try {
        cacheSug[base] = cacheSug[base] || (await (await fetch(`${raiz}recommendations/products.json?product_id=${base}&limit=10`)).json()).products || [];
        cacheSug[base].filter(p => p.available && p.handle !== "envoltura-de-regalo" && !enCarrito.includes(String(p.id)) && !elegidos.some(x => x.id === p.id))
          .forEach(p => {
            if (elegidos.length >= 3) return;
            const v = p.variants.find(x => x.available) || p.variants[0];
            elegidos.push({ id: p.id, vid: v.id, precio: v.price, url: p.url, vendor: p.vendor, nombre: p.title, variante: p.variants.length > 1 ? v.title : "",
                            img: p.featured_image ? p.featured_image + (p.featured_image.includes("?") ? "&" : "?") + "width=160" : "" });
          });
      } catch (e) {}
    }
    if (!elegidos.length) { caja.hidden = true; return; }
    $(".sugerencias-lista", caja).innerHTML = elegidos.map(p => {
      const img = p.img ? `<img src="${escHtml(p.img)}" alt="" loading="lazy">` : "";
      const variante = p.variante ? `<span>${escHtml(p.variante)}</span>` : "";
      const nota = p === alcanza ? `<p class="sug-nota">${escHtml(textos.llega_envio || "")}</p>` : "";
      return `<div class="sugerencia"><a class="sug-foto" href="${escHtml(p.url)}">${img}</a><div class="sug-info"><p class="marca-t">${escHtml(p.vendor)}</p><a href="${escHtml(p.url)}">${escHtml(sinMarca({ title: p.nombre, vendor: p.vendor }))}</a><p class="sug-precio">${variante}${dinero(p.precio)}</p>${nota}</div><button type="button" class="sug-agregar" data-sug-agregar="${+p.vid}">+ ${escHtml(textos.agregar_sug || "Agregar")}</button></div>`;
    }).join("");
    caja.hidden = false;
  }
  document.addEventListener("click", async e => {
    const b = e.target.closest("[data-sug-agregar]");
    if (!b) return;
    b.disabled = true;
    try { await agregar(b.dataset.sugAgregar, 1); } catch (err) { b.disabled = false; }
  });

  async function pedir(url, cuerpo) {
    const r = await fetch(raiz + url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ ...cuerpo, sections: SECCIONES, sections_url: location.pathname }) });
    const datos = await r.json();
    if (!r.ok) throw new Error(datos.description || datos.message || textos.error || "Error");
    return datos;
  }
  /* envoltura de regalo: la casilla agrega o quita la línea; después de cada cambio del carrito se deja
     la variante correcta ($4.50 o gratis desde $80), una sola unidad, y se quita si no quedan productos */
  const enPaginaCarrito = () => !!$(".pagina [data-envoltura]");
  async function sincronizarEnvoltura() {
    const e = $("[data-envoltura]");
    if (!e) return;
    const { correcta, actual, clave, cant, otros } = e.dataset;
    if (!actual) return;
    let cambios = null;
    if (+otros === 0) cambios = { [clave]: 0 };
    else if (actual !== correcta) cambios = { [actual]: 0, [correcta]: 1 };
    else if (+cant !== 1) cambios = { [clave]: 1 };
    if (!cambios) return;
    const datos = await pedir("cart/update.js", { updates: cambios });
    if (enPaginaCarrito()) location.reload(); else pintarSecciones(datos.sections);
  }
  document.addEventListener("change", async e => {
    const c = e.target.closest("[data-envoltura-casilla]");
    if (!c) return;
    const caja = c.closest("[data-envoltura]");
    c.disabled = true;
    try {
      const datos = c.checked
        ? await pedir("cart/add.js", { items: [{ id: +caja.dataset.correcta, quantity: 1 }] })
        : await pedir("cart/change.js", { id: caja.dataset.clave, quantity: 0 });
      if (enPaginaCarrito()) location.reload(); else pintarSecciones(datos.sections);
    } catch (err) { c.checked = !c.checked; c.disabled = false; const m = $("#carrito-error"); if (m) { m.textContent = err.message; m.hidden = false; } }
  });

  async function agregar(id, cantidad) {
    const datos = await pedir("cart/add.js", { items: [{ id: +id, quantity: cantidad }] });
    pintarSecciones(datos.sections);
  }
  document.addEventListener("click", async e => {
    const b = e.target.closest("[data-linea]");
    if (!b) return;
    const linea = +b.dataset.linea, cant = +b.dataset.cantidad;
    b.disabled = true;
    try { pintarSecciones((await pedir("cart/change.js", { line: linea, quantity: cant })).sections); }
    catch (err) { const m = $("#carrito-error"); if (m) { m.textContent = err.message; m.hidden = false; } b.disabled = false; }
  });
  document.addEventListener("change", e => {
    if (e.target.name !== "metodo_entrega") return;
    fetch(raiz + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { Entrega: e.target.value } }) });
  });

  /* "Agregar" -> "Agregado" con desenfoque corto, y vuelve */
  function confirmar(btn, volver) {
    const c = $(".contenido", btn);
    btn.classList.add("transicion");
    setTimeout(() => { c.textContent = textos.agregado || "Agregado"; btn.classList.remove("transicion"); }, 120);
    setTimeout(() => {
      if (!btn.isConnected) return;
      btn.classList.add("transicion");
      setTimeout(() => { if (btn.isConnected) { c.innerHTML = volver; btn.classList.remove("transicion"); } }, 120);
    }, 1500);
  }

  /* ---------- carruseles con flechas ---------- */
  function activarCarruseles(r = document) {
    $$(".carrusel", r).forEach(c => {
      if (c.dataset.listo) return; c.dataset.listo = "1";
      const marco = c.closest(".carrusel-marco"); if (!marco) return;
      const [a, b] = $$(".flecha", marco);
      if (!a || !b) return;
      const estado = () => { a.disabled = c.scrollLeft < 4; b.disabled = c.scrollLeft + c.clientWidth >= c.scrollWidth - 4; };
      c.addEventListener("scroll", estado, { passive: true }); estado();
      [a, b].forEach(btn => btn.addEventListener("click", () => c.scrollBy({ left: +btn.dataset.dir * c.clientWidth * 0.9, behavior: reducido() ? "auto" : "smooth" })));
    });
  }

  /* ---------- banner de diapositivas ---------- */
  function activarBanner(banner) {
    // el banner tarjeta separa fotos y textos; el de diapositivas los tiene juntos
    const hero = banner.matches("[data-hero], [data-banner-col]");
    const diapos = hero ? $$("[data-diapo]", banner) : $$(".diapo", banner), fotos = $$("[data-diapo-foto]", banner), puntos = $$(".punto-b", banner);
    if (diapos.length < 2) return;
    const dur = +banner.dataset.duracion || 6000;
    let actual = 0, pausadoUsuario = reducido() || banner.dataset.auto === "false", pausadoTemp = false, timer = null, restante = dur, inicio = 0;
    const pausa = $(".b-pausa", banner);
    const pintarPausa = () => {
      if (pausa) {
        $(".i-pausa", pausa).hidden = pausadoUsuario; $(".i-play", pausa).hidden = !pausadoUsuario;
        pausa.setAttribute("aria-label", pausadoUsuario ? textos.reproducir : textos.pausar);
      }
      banner.classList.toggle("pausado", pausadoUsuario || pausadoTemp);
    };
    const programar = () => {
      clearTimeout(timer);
      if (pausadoUsuario || pausadoTemp) return;
      inicio = performance.now(); timer = setTimeout(() => ir(actual + 1), restante);
    };
    const congelar = () => { clearTimeout(timer); restante = Math.max(400, restante - (performance.now() - inicio)); };
    const ir = n => {
      actual = (n + diapos.length) % diapos.length;
      diapos.forEach((d, i) => {
        const on = i === actual;
        d.classList.toggle("activa", on); on ? d.removeAttribute("aria-hidden") : d.setAttribute("aria-hidden", "true");
        $$("a", d).forEach(a => on ? a.removeAttribute("tabindex") : a.setAttribute("tabindex", "-1"));
        if (hero) { d.inert = !on; fotos[i] && fotos[i].classList.toggle("activa", on); }
      });
      if (hero) $(".hero-tarjeta", banner).classList.toggle("claro", diapos[actual].hasAttribute("data-claro"));
      puntos.forEach((p, i) => { p.classList.remove("actual"); p.classList.toggle("hecho", i < actual); p.setAttribute("aria-current", i === actual); });
      void puntos[actual].offsetWidth; puntos[actual].classList.add("actual");
      restante = dur; programar();
    };
    puntos.forEach((p, i) => p.addEventListener("click", () => ir(i)));
    $$("[data-paso]", banner).forEach(b => b.addEventListener("click", () => ir(actual + +b.dataset.paso)));
    pausa && pausa.addEventListener("click", () => { pausadoUsuario = !pausadoUsuario; if (pausadoUsuario) congelar(); pintarPausa(); programar(); });
    const temp = on => { if (on) congelar(); pausadoTemp = on; pintarPausa(); if (!on) programar(); };
    if (matchMedia("(hover: hover) and (pointer: fine)").matches) {
      banner.addEventListener("pointerenter", () => temp(true));
      banner.addEventListener("pointerleave", () => temp(false));
    }
    banner.addEventListener("focusin", () => temp(true));
    banner.addEventListener("focusout", e => { if (!banner.contains(e.relatedTarget)) temp(false); });
    // deslizar en el celular: basta un gesto rápido
    const zona = $(".diapos", banner) || banner; let x0 = null, t0 = 0;
    zona.addEventListener("pointerdown", e => { if (e.pointerType !== "mouse") { x0 = e.clientX; t0 = performance.now(); } });
    zona.addEventListener("pointerup", e => {
      if (x0 === null) return;
      const dx = e.clientX - x0, vel = Math.abs(dx) / Math.max(1, performance.now() - t0);
      if (Math.abs(dx) > 60 || (Math.abs(dx) > 20 && vel > 0.11)) ir(actual + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    zona.addEventListener("pointercancel", () => { x0 = null; });
    document.addEventListener("visibilitychange", () => temp(document.hidden));
    pintarPausa(); puntos[0].classList.add("actual"); programar();
  }

  /* ---------- pestañas de sensaciones ---------- */
  function activarPestanas(r) {
    const tabs = $$(".pestana", r), ind = $(".indicador", r);
    const mover = t => { if (t && ind) { ind.style.width = t.offsetWidth + "px"; ind.style.transform = `translateX(${t.offsetLeft}px)`; } };
    const notas = $(".sens-notas", r);
    tabs.forEach((tab, i) => {
      tab.addEventListener("click", () => {
        if (tab.getAttribute("aria-selected") === "true") return;
        tabs.forEach(x => { const on = x === tab; x.setAttribute("aria-selected", on); x.tabIndex = on ? 0 : -1; });
        mover(tab);
        const mostrar = () => {
          $$(".panel-tab", r).forEach(p => p.hidden = p.id !== tab.getAttribute("aria-controls"));
          if (notas) notas.textContent = tab.dataset.notas || "";
        };
        const visible = $$(".panel-tab", r).find(p => !p.hidden);
        if (reducido() || !visible) return mostrar();
        visible.classList.add("cambiando");
        setTimeout(() => { visible.classList.remove("cambiando"); mostrar(); }, 180);
      });
      tab.addEventListener("keydown", e => {
        const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key]; if (!d) return;
        e.preventDefault(); const sig = tabs[(i + d + tabs.length) % tabs.length]; sig.click(); sig.focus();
      });
    });
    requestAnimationFrame(() => mover(tabs.find(t => t.getAttribute("aria-selected") === "true")));
    new ResizeObserver(() => mover(tabs.find(t => t.getAttribute("aria-selected") === "true"))).observe($(".pestanas", r));
  }

  /* ---------- ficha de producto ---------- */
  function activarProducto(f) {
    const datos = JSON.parse($("script[data-producto]", f).textContent);
    const form = $("form[data-form-producto]", f);
    const idInput = $("input[name=id]", form), btn = $("[data-agregar]", f), cantOut = $("[data-cant]", f);
    let cant = 1;
    const elegidas = () => $$(".opcion", f).map(o => (o.querySelector("[aria-pressed=true]") || {}).dataset?.valor);
    const varianteDe = vals => datos.variants.find(v => v.options.every((o, i) => o === vals[i]));
    const pintar = v => {
      if (!v) { btn.disabled = true; $(".contenido", btn).textContent = textos.no_disponible; return; }
      idInput.value = v.id;
      cant = Math.max(1, Math.min(cant, v.cantidad > 0 ? v.cantidad : 1));
      cantOut.textContent = cant;
      $("[data-menos]", f).disabled = cant <= 1; $("[data-mas]", f).disabled = v.cantidad > 0 && cant >= v.cantidad;
      $$("[data-precio]", f).forEach(el => el.textContent = v.precio);
      const antes = $("[data-precio-antes]", f); if (antes) { antes.hidden = !v.antes; if (v.antes) antes.textContent = v.antes; }
      btn.disabled = !v.disponible;
      const bb = $("[data-barra-agregar]", f);
      if (bb) { bb.disabled = !v.disponible; bb.textContent = v.disponible ? textos.agregar_corto : textos.agotado; }
      const bv = $("[data-barra-variante]", f);
      if (bv && v.options.length && v.options[0] !== "Default Title") bv.textContent = v.options.join(" · ");
      $(".contenido", btn).innerHTML = v.disponible ? `${textos.agregar_carrito} · <span class="precio">${v.precio_total(cant)}</span>` : textos.agotado;
      $$(".opcion", f).forEach((o, i) => { const b = $("[data-elegido]", o); if (b) b.textContent = v.options[i]; });
      const st = $("[data-stock]", f);
      if (st) { st.textContent = v.cantidad > 0 && v.cantidad <= 5 ? textos.quedan.replace("__N__", v.cantidad) : (v.disponible ? textos.disponible : textos.agotado); st.classList.toggle("bajo", v.cantidad > 0 && v.cantidad <= 5); }
      if (v.media) { const m = $(`[data-media="${v.media}"]`, f); if (m) { $$(".galeria [data-media]", f).forEach(x => x.hidden = x !== m && x.classList.contains("principal")); m.hidden = false; } }
      const ar = $("[data-aroma-texto]", f); if (ar) { ar.textContent = v.sens_texto || ""; ar.hidden = !v.sens_texto; }
      const no = $("[data-aroma-notas]", f); if (no) { no.textContent = v.notas || ""; no.hidden = !v.notas; }
      const url = new URL(location.href); url.searchParams.set("variant", v.id); history.replaceState(null, "", url);
      cargarMismoAroma(f, v);
      cargarRecomendados(f);
    };
    datos.variants.forEach(v => { v.precio_total = n => (v.precio_num * n / 100).toLocaleString(datos.locale, { style: "currency", currency: datos.moneda }); });
    f.addEventListener("click", e => {
      const b = e.target.closest(".opcion [data-valor]");
      if (b && !b.disabled) {
        $$("[data-valor]", b.closest(".opcion")).forEach(x => x.setAttribute("aria-pressed", x === b));
        let v = varianteDe(elegidas());
        if (!v) v = datos.variants.find(x => x.options.includes(b.dataset.valor));
        if (v) $$(".opcion", f).forEach((o, i) => $$("[data-valor]", o).forEach(x => x.setAttribute("aria-pressed", x.dataset.valor === v.options[i])));
        pintar(v);
      }
      if (e.target.closest("[data-menos]")) { cant = Math.max(1, cant - 1); pintar(varianteDe(elegidas())); }
      if (e.target.closest("[data-mas]")) { cant += 1; pintar(varianteDe(elegidas())); }
    });
    // barra fija (celular): visible cuando el botón principal ya quedó arriba, fuera de la pantalla
    const barra = $("[data-barra-compra]", f);
    if (barra) {
      $("[data-barra-agregar]", barra).addEventListener("click", () => form.requestSubmit());
      new IntersectionObserver(([e]) => {
        const ver = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle("visible", ver);
        barra.toggleAttribute("inert", !ver); barra.setAttribute("aria-hidden", String(!ver));
        document.body.classList.toggle("con-barra", ver);
      }).observe(btn);
    }
    form.addEventListener("submit", async e => {
      e.preventDefault();
      const v = varianteDe(elegidas()); if (!v) return;
      const volver = $(".contenido", btn).innerHTML;
      try { await agregar(v.id, cant); confirmar(btn, volver); setTimeout(() => abrir("carrito"), 420); }
      catch (err) { const m = $("[data-error]", f); m.textContent = err.message; m.hidden = false; }
    });
    pintar(datos.variants.find(v => v.id === +idInput.value) || datos.variants[0]);
  }
  // "el mismo aroma en otros productos": búsqueda por etiqueta aroma-<aroma>, renderizada por la sección
  let ultimoAroma = null;
  async function cargarRecomendados(f) {
    const cont = $("[data-recomendados]");
    if (!cont || cont.dataset.cargado) return;
    cont.dataset.cargado = "1";
    try {
      const url = `${raiz}recommendations/products?product_id=${f.dataset.productoId}&limit=10&section_id=${cont.dataset.seccion}`;
      const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), "text/html");
      const tarjetas = $$(".tarjeta", doc).filter(t => t.dataset.producto !== String(f.dataset.productoId));
      const carr = $(".carrusel", cont);
      if (tarjetas.length) { carr.innerHTML = ""; tarjetas.slice(0, 8).forEach(t => carr.append(t)); cont.hidden = false; delete carr.dataset.listo; activarCarruseles(cont); activarRevelar(cont); }
    } catch (e) {}
  }
  async function cargarMismoAroma(f, v) {
    const cont = $("[data-mismo-aroma]");
    if (!cont || !v.aroma_tag || v.aroma_tag === ultimoAroma) return;
    ultimoAroma = v.aroma_tag;
    try {
      const url = `${raiz}search?type=product&options[prefix]=none&q=${encodeURIComponent(`tag:"${v.aroma_tag}"`)}&section_id=${cont.dataset.seccion}`;
      const html = await (await fetch(url)).text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const tarjetas = $$(".tarjeta", doc).filter(t => t.dataset.producto !== String(f.dataset.productoId));
      const carr = $(".carrusel", cont);
      if (tarjetas.length) { carr.innerHTML = ""; tarjetas.slice(0, 8).forEach(t => carr.append(t)); cont.hidden = false; delete carr.dataset.listo; activarCarruseles(cont); }
      else cont.hidden = true;
    } catch { cont.hidden = true; }
  }

  /* ---------- colección: los selectores llevan a la URL del filtro ---------- */
  document.addEventListener("change", e => {
    const s = e.target;
    if (s.matches("select[data-navegar]")) location.href = s.value;
    if (s.matches("select[data-orden]")) { const u = new URL(location.href); u.searchParams.set("sort_by", s.value); u.searchParams.delete("page"); location.href = u; }
  });

  /* ---------- idioma ---------- */
  document.addEventListener("click", e => {
    const b = e.target.closest("[data-idioma]"); if (!b) return;
    const f = b.closest("form"); $("input[name=locale_code]", f).value = b.dataset.idioma; f.submit();
  });

  /* ---------- banner tarjeta: color del texto automático según la foto ----------
     Mide la luz de una versión pequeña de la foto en la zona del texto (o del menú, si el banner no tiene texto)
     y marca el banner como claro (letras oscuras) u oscuro (letras blancas). */
  function luzDeFoto(url, zona) {
    return new Promise(listo => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const c = document.createElement("canvas"), w = (c.width = img.naturalWidth), h = (c.height = img.naturalHeight);
          const ctx = c.getContext("2d", { willReadFrequently: true });
          ctx.drawImage(img, 0, 0);
          const [x0, y0, x1, y1] = zona, d = ctx.getImageData(Math.floor(x0 * w), Math.floor(y0 * h), Math.max(1, Math.floor((x1 - x0) * w)), Math.max(1, Math.floor((y1 - y0) * h))).data;
          let suma = 0;
          for (let i = 0; i < d.length; i += 4) suma += (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255;
          listo(suma / (d.length / 4));
        } catch (e) { listo(null); }
      };
      img.onerror = () => listo(null);
      img.src = url;
    });
  }
  // imágenes con texto encima (sección Aromas por sensación): letras oscuras si la parte de abajo es clara
  function activarColorFotos(r = document) {
    $$("[data-color-auto]", r).forEach(async f => {
      const luz = await luzDeFoto(f.dataset.muestra, [0.05, 0.6, 0.95, 1]);
      if (luz !== null) f.classList.toggle("claro", luz > 0.6);
    });
  }
  function activarColorHero(hero) {
    const diapos = $$("[data-diapo]", hero), fotos = $$("[data-diapo-foto]", hero), tarjeta = $(".hero-tarjeta", hero);
    const ancho = matchMedia("(min-width: 760px)");
    const medir = () => diapos.forEach(async (d, i) => {
      const f = fotos[i];
      if (d.dataset.color !== "auto" || !f || !f.dataset.muestraPc) return;
      const zona = d.classList.contains("solo-imagen") ? [0.05, 0, 0.95, 0.18] : [0.18, 0.28, 0.82, 0.78];
      const luz = await luzDeFoto(ancho.matches ? f.dataset.muestraPc : f.dataset.muestraCel, zona);
      if (luz === null) return;
      const clara = luz > 0.6;
      d.toggleAttribute("data-claro", clara);
      f.classList.toggle("es-clara", clara);
      if (d.classList.contains("activa")) tarjeta.classList.toggle("claro", clara);
    });
    medir();
    ancho.addEventListener("change", medir);
  }

  /* ---------- banner tarjeta: la cabecera normal aparece al pasar el banner ---------- */
  let observaHero = null;
  function activarHero() {
    if (observaHero) observaHero.disconnect();
    const hero = $("[data-hero]");
    document.body.classList.toggle("en-inicio", !!hero);
    if (!hero) { document.body.classList.remove("pasado"); return; }
    observaHero = new IntersectionObserver(([e]) => document.body.classList.toggle("pasado", !e.isIntersecting), { rootMargin: "-80px 0px 0px 0px" });
    observaHero.observe(hero);
  }

  /* ---------- universos en el celular: el punto activo sigue al deslizar ---------- */
  function activarUniversos(r = document) {
    $$("[data-carrusel-u]", r).forEach(c => {
      if (c.dataset.listo) return; c.dataset.listo = "1";
      const puntos = $$(".puntos-u span", c.parentElement);
      if (!puntos.length) return;
      const marcar = () => {
        const tarjetas = [...c.children], izq = c.getBoundingClientRect().left;
        let mejor = 0, dist = Infinity;
        tarjetas.forEach((t, i) => { const d = Math.abs(t.getBoundingClientRect().left - izq - 16); if (d < dist) { dist = d; mejor = i; } });
        puntos.forEach((p, i) => p.classList.toggle("activo", i === mejor));
      };
      c.addEventListener("scroll", marcar, { passive: true });
    });
  }

  /* ---------- cabecera translúcida al bajar ---------- */
  function activarCabecera() {
    const c = $(".cabecera");
    if (!c) return;
    const marcar = () => c.classList.toggle("desplazada", scrollY > 8);
    addEventListener("scroll", marcar, { passive: true });
    marcar();
  }

  /* ---------- aparición al hacer scroll: títulos, bloques y tarjetas suben y aparecen, en cascada, una sola vez ---------- */
  const QUE_REVELAR = ".seccion-cab, .universo, .partida-foto, .imagen-texto > *, .manifiesto > *, .servicio, .marca-tile, .carrusel > .tarjeta, .grilla > *, .col-cab";
  let observaRevelar = null;
  function activarRevelar(r = document) {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) return;
    observaRevelar = observaRevelar || new IntersectionObserver(entradas => entradas.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.classList.add("revelado");
      observaRevelar.unobserve(e.target);
    }), { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    $$(QUE_REVELAR, r).forEach(el => {
      if (el.closest(".hero, .panel, [data-ficha]") || el.classList.contains("por-revelar")) return;
      // orden dentro de su grupo (cascada), con tope para que nada tarde demasiado
      const hermanos = [...el.parentElement.children].filter(x => x.matches(QUE_REVELAR));
      el.style.setProperty("--orden", Math.min(hermanos.indexOf(el), 5));
      el.classList.add("por-revelar");
      observaRevelar.observe(el);
    });
  }

  /* ---------- pop-up de bienvenida (10 %) ----------
     Una sola vez: a los N segundos, a mitad de página o al ir a cerrar la pestaña (computadora).
     Cerrado = no vuelve en 14 días; suscrito = no vuelve más. Al volver del envío del formulario muestra el código. */
  function activarPopup() {
    const p = $("[data-popup]");
    if (!p) return;
    const CLAVE = "sens_popup", DIAS = 14 * 864e5;
    const leer = () => { try { return JSON.parse(localStorage.getItem(CLAVE) || "null"); } catch (e) { return null; } };
    const guardar = estado => { try { localStorage.setItem(CLAVE, JSON.stringify({ estado, t: Date.now() })); } catch (e) {} };
    const enviado = (() => { try { return sessionStorage.getItem("sens_popup_envio") === "1"; } catch (e) { return false; } })();
    const limpiarEnvio = () => { try { sessionStorage.removeItem("sens_popup_envio"); } catch (e) {} };
    let abiertoPopup = false, previo = null, temporizador = null;
    const caja = $(".popup-caja", p), correo = $("#correo-popup", p);
    const abrir = paso => {
      if (abiertoPopup || $(".panel.abierto")) return;
      abiertoPopup = true; previo = document.activeElement;
      $("[data-paso-form]", p).hidden = paso === "codigo";
      $("[data-paso-codigo]", p).hidden = paso !== "codigo";
      p.hidden = false; p.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      requestAnimationFrame(() => requestAnimationFrame(() => p.classList.add("abierto")));
      setTimeout(() => { const f = paso === "codigo" ? $(".popup-codigo", p) : correo; f && f.focus({ preventScroll: true }); }, 380);
      quitarDisparadores();
    };
    const cerrar = () => {
      if (!abiertoPopup) return;
      abiertoPopup = false;
      p.classList.remove("abierto"); p.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      setTimeout(() => { p.hidden = true; }, 420);
      if (!(leer() || {}).estado || leer().estado !== "suscrito") guardar("cerrado");
      if (previo && previo.isConnected) previo.focus({ preventScroll: true });
    };
    p.addEventListener("click", e => {
      const c = e.target.closest("[data-popup-cerrar]");
      if (!c) return;
      if (c.tagName !== "A") e.preventDefault();
      cerrar();
    });
    document.addEventListener("keydown", e => {
      if (!abiertoPopup) return;
      if (e.key === "Escape") { cerrar(); return; }
      if (e.key === "Tab") {   // el foco se queda dentro del pop-up
        const f = $$("button:not([hidden]), a[href], input:not([type=hidden])", caja).filter(x => x.offsetParent);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    const form = $("#form-popup", p);
    if (form) form.addEventListener("submit", () => { try { sessionStorage.setItem("sens_popup_envio", "1"); } catch (e) {} });
    $$("[data-copiar]", p).forEach(b => b.addEventListener("click", async () => {
      try { await navigator.clipboard.writeText(b.dataset.copiar); } catch (e) {}
      const t = $("[data-copiado-texto]", b); if (t) t.textContent = t.dataset.copiado;
    }));

    // volviendo del formulario del pop-up: código (si salió bien) o el formulario con el error
    if (enviado) {
      limpiarEnvio();
      if (location.search.includes("customer_posted=true")) { guardar("suscrito"); abrir("codigo"); return; }
      if ($("[data-popup-error]", p)) { abrir("form"); return; }
    }
    const previoEstado = leer();
    if (previoEstado && (previoEstado.estado === "suscrito" || Date.now() - previoEstado.t < DIAS)) return;

    // disparadores: tiempo, mitad de página, salida por arriba (computadora)
    const porScroll = () => { if (scrollY > (document.documentElement.scrollHeight - innerHeight) * 0.5) abrir("form"); };
    const porSalida = e => { if (e.clientY <= 0 && !e.relatedTarget) abrir("form"); };
    function quitarDisparadores() {
      clearTimeout(temporizador);
      removeEventListener("scroll", porScroll);
      document.removeEventListener("mouseout", porSalida);
    }
    temporizador = setTimeout(() => abrir("form"), +p.dataset.retraso || 8000);
    addEventListener("scroll", porScroll, { passive: true });
    if (matchMedia("(hover: hover) and (pointer: fine)").matches) document.addEventListener("mouseout", porSalida);
  }

  /* ---------- fotos con fundido al cargar ---------- */
  function marcarFotos(r = document) {
    $$(".foto > img:not(.foto-2):not(.cargada)", r).forEach(img => {
      const listo = () => img.classList.add("cargada");
      if (img.complete && img.naturalWidth) { img.classList.add("cargada"); return; }
      img.addEventListener("load", listo, { once: true });
      img.addEventListener("error", listo, { once: true });
    });
  }
  // fotos que llegan después (carrito, "mismo aroma", secciones del editor)
  new MutationObserver(m => m.forEach(x => x.addedNodes.forEach(n => { if (n.nodeType === 1) marcarFotos(n.parentElement || n); }))).observe(document.body, { childList: true, subtree: true });

  /* ---------- buscador: resultados mientras se escribe (API de búsqueda predictiva de Shopify) ---------- */
  function activarBuscador() {
    const campo = $("[data-buscar-q]"), caja = $("[data-buscar-res]"), explora = $("[data-buscar-explora]");
    if (!campo || !caja) return;
    let espera = 0, pedido = null;
    const urlTodos = q => `${raiz}search?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last`;
    const precio = p => {
      const n = parseFloat(p.price);
      return isNaN(n) ? "" : "$" + n.toFixed(2);
    };
    function pintar(q, r) {
      const prods = (r.products || []).filter(p => p.handle !== "envoltura-de-regalo");
      const cols = r.collections || [];
      if (!prods.length && !cols.length) {
        caja.innerHTML = `<p class="buscador-vacio">${escHtml((textos.busqueda_vacia || "").replace("__Q__", q))}</p>`;
        return;
      }
      let html = "";
      if (cols.length) html += `<p class="buscador-titulo">${escHtml(textos.busqueda_colecciones || "")}</p><div class="buscador-chips">${cols.map(c => `<a href="${escHtml(c.url)}">${escHtml(c.title)}</a>`).join("")}</div>`;
      if (prods.length) {
        html += `<p class="buscador-titulo">${escHtml(textos.busqueda_productos || "")}</p><div class="buscador-prods">` + prods.map(p => {
          const src = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          const img = src ? `<img src="${escHtml(src)}${src.includes("?") ? "&" : "?"}width=160" alt="" width="64" height="64" loading="lazy">` : "";
          return `<a class="buscador-prod" href="${escHtml(p.url)}"><span class="buscador-foto">${img}</span><span class="buscador-info"><span class="marca-t">${escHtml(p.vendor || "")}</span><span class="buscador-nombre">${escHtml(sinMarca({ title: p.title, vendor: p.vendor || "" }))}</span><span class="buscador-precio">${precio(p)}</span></span></a>`;
        }).join("") + `</div>`;
      }
      html += `<a class="buscador-todos" href="${urlTodos(q)}">${escHtml(textos.busqueda_todos || "")} →</a>`;
      caja.innerHTML = html;
    }
    async function buscar() {
      const q = campo.value.trim();
      if (pedido) pedido.abort();
      if (q.length < 2) { caja.innerHTML = ""; explora && (explora.hidden = false); return; }
      explora && (explora.hidden = true);
      pedido = new AbortController();
      caja.classList.add("cargando");
      try {
        const url = `${raiz}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`;
        const r = await fetch(url, { signal: pedido.signal }).then(x => x.json());
        pintar(q, (r.resources && r.resources.results) || {});
      } catch (e) { if (e.name !== "AbortError") caja.innerHTML = ""; }
      caja.classList.remove("cargando");
    }
    campo.addEventListener("input", () => { clearTimeout(espera); espera = setTimeout(buscar, 180); });
  }

  /* ---------- arranque ---------- */
  activarCarruseles();
  activarUniversos();
  marcarFotos();
  activarCabecera();
  activarRevelar();
  activarPopup();
  activarBuscador();
  sincronizarEnvoltura().catch(() => {});
  cargarSugerencias();
  $$(".banner, [data-hero], [data-banner-col]").forEach(activarBanner);
  activarHero();
  $$("[data-hero], [data-banner-col]").forEach(activarColorHero);
  activarColorFotos();
  $$("[data-pestanas]").forEach(activarPestanas);
  $$("[data-ficha]").forEach(activarProducto);
  document.addEventListener("shopify:section:unload", () => setTimeout(activarHero, 0));
  document.addEventListener("shopify:section:load", e => {
    activarCarruseles(e.target);
    activarUniversos(e.target);
    activarRevelar(e.target);
    $$(".banner, [data-hero], [data-banner-col]", e.target).forEach(activarBanner);
    activarHero();
    $$("[data-hero], [data-banner-col]", e.target).forEach(activarColorHero);
    activarColorFotos(e.target);
    $$("[data-pestanas]", e.target).forEach(activarPestanas);
    $$("[data-ficha]", e.target).forEach(activarProducto);
  });
})();
